import { N8N_CONFIG_URL } from "../constants";

/**
 * @param {string|undefined} [subdomainOverride] If non-empty after trim, used as `subdomain` query param; otherwise hostname first segment.
 */
export const getConfig = async (subdomainOverride) => {
  const trimmed =
    typeof subdomainOverride === "string" ? subdomainOverride.trim() : "";
  const subdomain =
    trimmed !== "" ? trimmed : window.location.hostname.split(".")[0];
  const url = new URL(N8N_CONFIG_URL);
  url.searchParams.set("subdomain", subdomain);

  const response = await fetch(url.toString());
  if (!response.ok) {
    throw new Error(`Config fetch failed: ${response.status}`);
  }
  const raw = await response.json();
  // n8n peut renvoyer la config sous `partnerConfig` (Code node qui merge sur l’item Airtable)
  if (raw && typeof raw.partnerConfig === "object" && raw.partnerConfig !== null) {
    const pc = raw.partnerConfig;
    return {
      ...pc,
      subdomainEmail:
        pc.subdomainEmail != null ? pc.subdomainEmail : raw.subdomainEmail,
    };
  }
  return raw;
};
